import { useEffect, useState } from "react";
import Navbar from "../../Navbar/navbar";
import { baseUrl } from "../../../Environments/environment";
import axios from "axios";
import { useParams } from "react-router-dom";
import moment from "moment";
import momentTimeZone from "moment-timezone";
import LoadingSpinner from "../../LoadingSpinner/LoadingSpinner";
import { Tick } from "../../../icons/Tick";
import { useSelector, useDispatch } from "react-redux";
import houseKeeping from "../../../icons/houseKeeping.png";
import {
	addSelectedAddOn,
	filterAddOnRequests,
	filterCheckInOutRequsts,
	setAllAddOns,
	setEarlyCheckInTime,
	setGuestAddons,
	setGuestCheckInOutRequests,
	setLateCheckOutTime,
} from "../../../redux/addOn/addOnSlice";
import DateandTimePicker from "./DateandTimePicker";
import LateCheckoutTimePicker from "./LateCheckoutTimePicker";
import { ToastContainer, toast, Bounce } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import HouseKeepingRequestAddOn from "../../Services/HouseKeepingRequestAddOn";
import { isOutsideServiceHours } from "../../../utils/housekeeping.js";
const getFormattedDate = () => {
	const today = new Date();
	const month = String(today.getMonth() + 1).padStart(2, "0"); // getMonth() returns month from 0-11, so add 1
	const day = String(today.getDate()).padStart(2, "0");
	const year = today.getFullYear();

	return `${month}/${day}/${year}`;
};
const convert24to12 = (time24) => {
	try {
		return moment(time24, "HH:mm").format("hh:mm A");
	} catch (error) {
		console.error("Error converting 24h to 12h format:", error);
		return "";
	}
};

// Convert 12-hour format to 24-hour format
const convert12to24 = (time12) => {
	try {
		return moment(time12, "hh:mm A").format("HH:mm");
	} catch (error) {
		console.error("Error converting 12h to 24h format:", error);
		return "";
	}
};
const convertUtcToIst = (utcTime) => {
	return momentTimeZone.utc(utcTime).tz("Asia/Kolkata").format("hh:mm A");
};
export const CheckInAddOn = () => {
	const guestid = useParams();
	const guestSessionId = guestid.id;
	const [guest, setGuest] = useState("");
	const [addOns, setAddOns] = useState(null);
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [requestSentStatus, setRequestSentStatus] = useState({}); // Object to track requestSent status for each add-on
	const [selectedAddOn, setSelectedAddOn] = useState(null); // Store selected add-on for the modal
	const [propertyCheckInTime, setPropertyCheckInTime] = useState("");
	const [propertyCheckOutTime, setPropertyCheckOutTime] = useState("");
	const [propertyEarlyCheckInTime, setPropertyEarlyCheckInTime] = useState("");
	const [propertyLateCheckOutTime, setPropertyLateCheckOutTime] = useState("");
	const [propertyTimeZone, setPropertyTimeZone] = useState(null);
	const [selectedTime, setSelectedTime] = useState(propertyCheckInTime);
	const [selectedDate, setSelectedDate] = useState(getFormattedDate());
	const [isLoading, setIsLoading] = useState(false);
	const [requestStatus, setRequestStatus] = useState(null);
	const [preArrivalFlow, setPreArrivalFlow] = useState(null);
	const [arrivalTime, setArrivalTime] = useState("");
	const [loadingAddOnId, setLoadingAddOnId] = useState(null);
	const [showEarlyCheckInButton, setShowEarlyCheckInButton] = useState(false);
	const [lateCheckoutRequestStatus, setlateCheckoutRequestStatus] =
		useState(null);
	const [lateCheckoOutSelectedTime, setLateCheckoOutSelectedTime] =
		useState("");
	const [showLateCheckOutButton, setShowLateCheckOutButton] = useState(false);
	const [isLateCheckOutModalOpen, setIsLateCheckOutModalOpen] = useState(false);
	const [lateCheckOutFlag, setLateCheckOutFlag] = useState(false);
	const [isLateCheckOutLoading, setIsLateCheckOutLoading] = useState(false);
	const [selectedHouseKeepingOptions, setSelectedHouseKeepingOptions] =
		useState([]);
	const [sentHouseKeepingRequest, setSentHouseKeepingRequest] = useState(false);
	const [houseKeepingRequests, setHouseKeepingRequests] = useState([]);
	const [isHouseKeepingModalOpen, setIsHouseKeepingModalOpen] = useState(false);

	const storeAddOns = useSelector((state) => state.addOn);
	const dispatch = useDispatch();
	const handleSendHouseKeepingRequest = async () => {
		const houseKeeping = addOns.find((item) => {
			if (item.name === "House Keeping") return item;
		});
		setIsLoading(true);
		console.log(houseKeeping._id);
		setLoadingAddOnId(houseKeeping._id);
		try {
			const data = await axios.post(
				`${baseUrl}/guestApi/${guestSessionId}/houseKeepingRequest`,
				{
					name: houseKeeping.name,
					description: houseKeeping.description,
					options: selectedHouseKeepingOptions,
				},
			);
			if (data.status === 200) {
				toast.success("Request sent successfully");
				setSentHouseKeepingRequest(true);
			}
		} catch (e) {
			toast.error(e.response.data.message);
			console.log(e);
		} finally {
			setIsLoading(false);
			setLoadingAddOnId(null);
		}
	};
	const getHouseKeepingRequests = async () => {
		try {
			const response = await axios.get(
				`${baseUrl}/guestApi/${guestSessionId}/houseKeepingRequest`,
			);
			setHouseKeepingRequests(response.data.result);
		} catch (error) {
			console.error("Error fetching guest data:", error);
		}
	};
	useEffect(() => {
		getHouseKeepingRequests();
	}, [sentHouseKeepingRequest]);
	const handleHouseKeepingOptionChange = (e) => {
		if (e.target.checked) {
			setSelectedHouseKeepingOptions([
				...selectedHouseKeepingOptions,
				e.target.value,
			]);
		} else {
			setSelectedHouseKeepingOptions(
				selectedHouseKeepingOptions.filter(
					(option) => option !== e.target.value,
				),
			);
		}
	};
	const [settings, setSettings] = useState(null);

	const getWorkFlow = async () => {
		try {
			const response = await axios.get(
				`${baseUrl}/guestApi/${guestSessionId}/workflow`,
			);

			setSettings(response.data.result.settingFlow);
			setPreArrivalFlow(response.data.result.preArrivalFlow);
			setPropertyCheckInTime(
				response.data.result.settingFlow.standardCheckinTime,
			);
			setArrivalTime(response.data.result.settingFlow.standardCheckinTime);
			setPropertyTimeZone(response.data.result.settingFlow.timezone);
			setPropertyCheckOutTime(
				response.data.result.settingFlow.standardCheckoutTime,
			);
			if (
				response.data.result &&
				response.data.result.addOnsFlow &&
				response.data.result.addOnsFlow.checkInOutAddOns.length > 0 &&
				response.data.result.addOnsFlow.checkInOutAddOns[0].enabled
			)
				setPropertyEarlyCheckInTime(
					response.data.result.addOnsFlow.checkInOutAddOns[0],
				);

			if (
				response.data.result &&
				response.data.result.addOnsFlow &&
				response.data.result.addOnsFlow.checkInOutAddOns.length > 0 &&
				response.data.result.addOnsFlow.checkInOutAddOns[1].enabled
			)
				setPropertyLateCheckOutTime(
					response.data.result.addOnsFlow.checkInOutAddOns[1],
				);
			const tempArr = [
				...response.data.result.addOnsFlow.checkInOutAddOns,
				...response.data.result.addOnsFlow.customAddOns,
			];
			if (guest.status && guest.status.currentStatus === "In House") {
				tempArr.unshift(response.data.result.addOnsFlow.houseKeepingAddOns);
			}

			setAddOns(tempArr);
			dispatch(setAllAddOns(tempArr));
		} catch (error) {
			console.error("Error submitting data:", error);
		}
	};

	const getGuest = async () => {
		try {
			const response = await axios.get(
				`${baseUrl}/guestApi/${guestSessionId}/guest`,
			);
			setGuest(response.data.result);
		} catch (error) {
			console.error("Error submitting data:", error);
		}
	};

	useEffect(() => {
		const fetchData = async () => {
			await getGuest();
		};

		fetchData();
	}, []);

	const getGuestCheckInOutRequests = async () => {
		try {
			const response = await axios.get(
				`${baseUrl}/guestApi/${guestSessionId}/checkInOutRequest`,
			);
			dispatch(setGuestCheckInOutRequests(response.data.result));
			dispatch(filterCheckInOutRequsts(response.data.result));
		} catch (error) {
			console.error("Error fetching guest data:", error);
		}
	};
	const getGuestAddons = async () => {
		try {
			const response = await axios.get(
				`${baseUrl}/guestApi/${guestSessionId}/addOns`,
			);
			dispatch(filterAddOnRequests(response.data.result));
			dispatch(setGuestAddons(response.data.result));
		} catch (error) {
			console.error("Error fetching guest data:", error);
		}
	};

	useEffect(() => {
		getGuestCheckInOutRequests();
		getGuestAddons();
	}, [requestStatus, lateCheckoutRequestStatus]);
	useEffect(() => {
		getWorkFlow();
	}, [guest]);
	useEffect(() => {
		if (selectedTime && selectedTime !== propertyCheckInTime) {
			setShowEarlyCheckInButton(true);
		} else {
			setShowEarlyCheckInButton(false);
		}
	}, [selectedTime, propertyCheckInTime]);
	useEffect(() => {
		if (
			lateCheckoOutSelectedTime &&
			lateCheckoOutSelectedTime !== propertyCheckOutTime
		) {
			setShowLateCheckOutButton(true);
		} else {
			setShowLateCheckOutButton(false);
		}
	}, [lateCheckoOutSelectedTime, propertyCheckOutTime]);

	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	const handleSendRequest = (addOn) => {
		setSelectedAddOn(addOn);
		if (addOn.addOnType != "CustomAddon") {
			setIsModalOpen(true);
		} else {
			handleConfirmRequest(addOn);
		} // Open modal
	};

	function formatDateTime(date, time) {
		const [day, month, year] = date.split("-");
		const formattedDate = `${year}-${month}-${day}`;

		// Combine the formatted date and time into a single string in the format 'YYYY-MM-DDTHH:mm:ss'
		const dateTimeString = `${formattedDate}T${time}Z`; // 'Z' makes it UTC

		// Return the formatted date-time string if valid
		// const parsedDate = new Date(dateTimeString);
		// if (Number.isNaN(parsedDate.getTime())) {
		//   throw new Error("Invalid date or time format");
		// }

		return dateTimeString;
	}
	const handleEarlyCheckInAddon = async (time) => {
		const formattedTime = convert12to24(time);
		const earlyCheckInAddon = addOns.find((item) =>
			item.name.toLowerCase().includes("early check in"),
		);
		console.log("earlyCheckInAddon", earlyCheckInAddon);
		const data = {
			earlyCheckInDateTime: formatDateTime(
				moment(guest.checkIn).format("DD-MM-YYYY"),
				formattedTime,
			),
			requestType: "earlyCheckIn",
			checkInOutRequestId: earlyCheckInAddon._id,
		};
		try {
			setIsLoading(true);
			setLoadingAddOnId(earlyCheckInAddon._id);
			const response = await axios.post(
				`${baseUrl}/guestApi/${guestSessionId}/checkInOutRequest`,
				data,
			);

			if (response.status === 200) {
				setRequestStatus("success"); // Update the request status to success
				dispatch(addSelectedAddOn(earlyCheckInAddon._id));
				// console.log("Request sent successfully!");
			} else {
				setRequestStatus("failure"); // Update the request status to failure
				// console.log("Request failed. Please try again.");
			}
		} catch (error) {
			setRequestStatus("failure"); // Update the request status to failure
			console.log(error);
			// toast.error("Request failed. Please try again.");
		} finally {
			setLoadingAddOnId(null);
			setIsLoading(false); // Ensure loading state is reset
		}
	};

	const handleLateCheckOutAddon = async (time) => {
		const formattedTime = convert12to24(time);
		const lateCheckOutAddon = addOns.find((item) =>
			item.name.toLowerCase().includes("late check out"),
		);
		console.log("lateCheckOutAddon", lateCheckOutAddon);
		const data = {
			lateCheckOutDateTime: formatDateTime(
				moment(guest.checkOut).format("DD-MM-YYYY"),
				formattedTime,
			),
			requestType: "lateCheckOut",
			checkInOutRequestId: lateCheckOutAddon._id,
		};
		try {
			setIsLateCheckOutLoading(true);
			setLoadingAddOnId(lateCheckOutAddon._id);
			const response = await axios.post(
				`${baseUrl}/guestApi/${guestSessionId}/checkInOutRequest`,
				data,
			);

			if (response.status === 200) {
				setlateCheckoutRequestStatus("success"); // Update the request status to success
				dispatch(addSelectedAddOn(lateCheckOutAddon._id));
				// dispatch(setLateCheckOutTime(time));
				//    console.log("Request sent successfully!");
			} else {
				setlateCheckoutRequestStatus("failure"); // Update the request status to failure
				//  console.log("Request failed. Please try again.");
			}
		} catch (error) {
			setlateCheckoutRequestStatus("failure"); // Update the request status to failure
			toast.error(error.response.data.error.message);
			console.log(error);
			//toast.error("Request failed. Please try again.");
		} finally {
			setLoadingAddOnId(null);
			setIsLateCheckOutLoading(false); // Ensure loading state is reset
		}
	};
	const handleConfirmRequest = async (addOn) => {
		await sendRequestToBackend(addOn);

		setIsModalOpen(false); // Close modal
	};

	const sendRequestToBackend = async (selectedAddOn) => {
		console.log("sendRequestToBack", selectedAddOn);
		const data = {
			addOnsId: selectedAddOn._id,
		};
		try {
			setIsLoading(true);
			setLoadingAddOnId(selectedAddOn._id);
			setRequestStatus("idle");
			const response = await axios.post(
				`${baseUrl}/guestApi/${guestSessionId}/addOnsRequest`,
				data,
			);
			if (response.status === 201) {
				setRequestStatus("success"); // Update the request status to success
				dispatch(addSelectedAddOn(selectedAddOn));
				// console.log("Request sent successfully!");
			} else {
				setRequestStatus("failure"); // Update the request status to failure
				// console.log("Request failed. Please try again.");
			}
		} catch (error) {
			setRequestStatus("failure"); // Update the request status to failure
			console.log(error);
			//toast.error("Request failed. Please try again.");
		} finally {
			setLoadingAddOnId(null);
			setIsLoading(false); // Ensure loading state is reset
		}
	};

	return (
		<>
			<Navbar counter={0} />
			{!addOns && <LoadingSpinner />}

			{/* Main content */}
			{addOns && (
				<div className="relative h-screen overflow-auto">
					<div className="flex flex-col justify-start items-center bg-gray-900 min-h-full w-full">
						<div
							className={`bg-white p-4 rounded-lg shadow-md w-full max-w-sm mx-6 my-6`}
						>
							<div className={`text-gray-400 flex justify-between`}>
								<div>
									<div className="text-lg font-poppins mb-2">Add-Ons</div>
								</div>
							</div>
							<div className="mt-4 mb-4">
								<div className="space-y-4">
									{storeAddOns.allAddOns
										.filter(
											(addOn) =>
												!(
													addOn.name?.toLowerCase().includes("early") &&
													guest.status.currentStatus === "In House"
												),
										)
										.map((addOn) => (
											<div key={addOn._id} className="rounded-md">
												<div className="bg-gray-200  mb-2 rounded-md">
													<img
														src={(() => {
															if (addOn.name?.toLowerCase().includes("early")) {
																return "https://onelyk-images-bucket.s3.us-east-1.amazonaws.com/addOns/early+check+in.png";
															} else if (
																addOn.name?.toLowerCase().includes("late")
															) {
																return "https://onelyk-images-bucket.s3.us-east-1.amazonaws.com/addOns/late+check+out.png";
															} else if (addOn.name === "House Keeping") {
																return houseKeeping;
															} else if (addOn.image) {
																return addOn.image;
															} else {
																return "https://st3.depositphotos.com/1022597/35608/i/450/depositphotos_356083076-stock-photo-grey-stone-texture-useful-background.jpg";
															}
														})()}
														className="w-full h-36"
													/>
												</div>
												<div className="flex justify-between">
													<div className="text-lg font-semibold">
														{addOn.name}
													</div>
													<div className="text-lg font-semibold">
														{!addOn.paid ||
														addOn.price === undefined ||
														addOn.price === 0
															? ""
															: `$${addOn.price}`}
													</div>
												</div>
												<div className="text-gray-500 mb-2 text-sm flex justify-start">
													{addOn.description}
												</div>
												{addOn.addOnType !== "CustomAddon" ? (
													<>
														{addOn.name.toLowerCase().includes("early") ? (
															<>
																<button
																	onClick={() => setIsModalOpen(true)}
																	//className="max-w-sm mx-auto mt-4 flex flex-row items-center justify-center w-full border-2 py-2 rounded-lg shadow-md focus:outline-none focus:shadow-outline bg-indigo-600 text-white border-gray-50 hover:bg-indigo-400"
																	//className="w-full border border-gray-300 rounded py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
																	className="w-full py-2 border border-indigo-600 text-indigo-600 rounded-md hover:bg-indigo-50 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center"
																>
																	Send Request
																</button>
																{loadingAddOnId === addOn._id && (
																	<button
																		className="w-full py-2 border border-indigo-600 text-indigo-600 rounded-md hover:bg-indigo-50 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center"
																		onClick={() => handleSendRequest(addOn)}
																		disabled={loadingAddOnId === addOn._id}
																	>
																		{loadingAddOnId === addOn._id && (
																			<>
																				<svg
																					className="animate-spin -ml-1 mr-2 h-5 w-5 text-indigo-600"
																					xmlns="http://www.w3.org/2000/svg"
																					fill="none"
																					viewBox="0 0 24 24"
																				>
																					<circle
																						className="opacity-25"
																						cx="12"
																						cy="12"
																						r="10"
																						stroke="currentColor"
																						strokeWidth="4"
																					/>
																					<path
																						className="opacity-75"
																						fill="currentColor"
																						d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
																					/>
																				</svg>
																				Processing...
																			</>
																		)}
																	</button>
																)}

																{storeAddOns?.guestCheckInOutRequests?.some(
																	(selectedAddOn) =>
																		selectedAddOn.requestType ===
																			"earlyCheckIn" &&
																		selectedAddOn.requestStatus === "Requested",
																) && (
																	<button
																		className="w-full py-2 bg-green-100 text-green-700 rounded-md flex items-center justify-center"
																		disabled
																	>
																		<span className="mr-2">
																			<Tick />
																		</span>
																		Request Sent
																	</button>
																)}
															</>
														) : addOn.name.toLowerCase().includes("late") ? (
															<>
																<button
																	onClick={() =>
																		setIsLateCheckOutModalOpen(true)
																	}
																	//className="max-w-sm mx-auto mt-4 flex flex-row items-center justify-center w-full border-2 py-2 rounded-lg shadow-md focus:outline-none focus:shadow-outline bg-indigo-600 text-white border-gray-50 hover:bg-indigo-400"
																	className="w-full py-2 border border-indigo-600 text-indigo-600 rounded-md hover:bg-indigo-50 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center"
																>
																	Send Request
																</button>

																{loadingAddOnId === addOn._id && (
																	<button
																		className="w-full py-2 border border-indigo-600 text-indigo-600 rounded-md hover:bg-indigo-50 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center"
																		onClick={() => handleSendRequest(addOn)}
																		disabled={loadingAddOnId === addOn._id}
																	>
																		{loadingAddOnId === addOn._id && (
																			<>
																				<svg
																					className="animate-spin -ml-1 mr-2 h-5 w-5 text-indigo-600"
																					xmlns="http://www.w3.org/2000/svg"
																					fill="none"
																					viewBox="0 0 24 24"
																				>
																					<circle
																						className="opacity-25"
																						cx="12"
																						cy="12"
																						r="10"
																						stroke="currentColor"
																						strokeWidth="4"
																					/>
																					<path
																						className="opacity-75"
																						fill="currentColor"
																						d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
																					/>
																				</svg>
																				Processing...
																			</>
																		)}
																	</button>
																)}
																{storeAddOns?.guestCheckInOutRequests?.some(
																	(selectedAddOn) =>
																		selectedAddOn.requestType ===
																			"lateCheckOut" &&
																		selectedAddOn.requestStatus === "Requested",
																) && (
																	<button
																		className="w-full py-2 bg-green-100 text-green-700 rounded-md flex items-center justify-center"
																		disabled
																	>
																		<span className="mr-2">
																			<Tick />
																		</span>
																		Request Sent
																	</button>
																)}
															</>
														) : (
															<button
																className="w-full py-2 border border-indigo-600 text-indigo-600 rounded-md hover:bg-indigo-50 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center"
																onClick={() => {
																	console.log(addOn._id);
																	const houseKeeping = addOns.find(
																		(item) => item.name === "House Keeping",
																	);

																	if (
																		isOutsideServiceHours(
																			houseKeeping,
																			settings,
																		)
																	) {
																		toast.error(
																			"You’re contacting a service outside business hours. Please reach out to the front desk.",
																		);
																		return;
																	}

																	setIsHouseKeepingModalOpen(true);
																}}
																disabled={loadingAddOnId === addOn._id}
															>
																{loadingAddOnId === addOn._id ? (
																	<>
																		<svg
																			className="animate-spin -ml-1 mr-2 h-5 w-5 text-indigo-600"
																			xmlns="http://www.w3.org/2000/svg"
																			fill="none"
																			viewBox="0 0 24 24"
																		>
																			<circle
																				className="opacity-25"
																				cx="12"
																				cy="12"
																				r="10"
																				stroke="currentColor"
																				strokeWidth="4"
																			/>
																			<path
																				className="opacity-75"
																				fill="currentColor"
																				d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
																			/>
																		</svg>
																		Processing...
																	</>
																) : houseKeepingRequests.length === 0 ? (
																	"Send Request"
																) : (
																	"Send New Request"
																)}
															</button>
														)}
													</>
												) : storeAddOns.guestAddons.some(
														(selectedAddOn) =>
															selectedAddOn.addOnsId === addOn._id &&
															selectedAddOn.requestStatus === "Requested",
													) ? (
													<button
														className="w-full py-2 bg-green-100 text-green-700 rounded-md flex items-center justify-center"
														disabled
													>
														<span className="mr-2">
															<Tick />
														</span>
														Request Sent
													</button>
												) : (
													<button
														className="w-full py-2 border border-indigo-600 text-indigo-600 rounded-md hover:bg-indigo-50 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center"
														onClick={() => handleSendRequest(addOn)}
														disabled={loadingAddOnId === addOn._id}
													>
														{loadingAddOnId === addOn._id ? (
															<>
																<svg
																	className="animate-spin -ml-1 mr-2 h-5 w-5 text-indigo-600"
																	xmlns="http://www.w3.org/2000/svg"
																	fill="none"
																	viewBox="0 0 24 24"
																>
																	<circle
																		className="opacity-25"
																		cx="12"
																		cy="12"
																		r="10"
																		stroke="currentColor"
																		strokeWidth="4"
																	/>
																	<path
																		className="opacity-75"
																		fill="currentColor"
																		d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
																	/>
																</svg>
																Processing...
															</>
														) : houseKeepingRequests.length === 0 ? (
															"Send Request"
														) : (
															"Send New Request"
														)}
													</button>
												)}
											</div>
										))}
								</div>
							</div>
						</div>
					</div>

					{/* Modal */}
					{isModalOpen && (
						<div className="fixed inset-0 bg-gray-700 bg-opacity-70 z-40">
							{guest && (
								<DateandTimePicker
									isModalOpen={isModalOpen}
									setIsModalOpen={setIsModalOpen}
									setRequestSent={(time) => {
										setSelectedTime(time);
										//dispatch(setEarlyCheckInTime(time));
										handleEarlyCheckInAddon(time);
									}}
									addon={storeAddOns.allAddOns.find((addon) => {
										if (
											addon.addOnType !== "CustomAddon" &&
											addon.name
												.toLowerCase()
												.replace(/\s+/g, "")
												.includes("early")
										)
											return addon;
									})}
									date={guest.checkIn}
									propertyEarlyCheckInTime={propertyEarlyCheckInTime}
									propertyTime={propertyCheckInTime}
									propertyTimeZone={propertyTimeZone}
								/>
							)}
						</div>
					)}
					{isHouseKeepingModalOpen && (
						<div className="fixed inset-0 bg-gray-700 bg-opacity-70 z-40">
							{guest && (
								<HouseKeepingRequestAddOn
									houseKeeping={addOns.find((item) => {
										if (item.name === "House Keeping") return item;
									})}
									isModalOpen={isHouseKeepingModalOpen}
									setIsModalOpen={setIsHouseKeepingModalOpen}
									handleSendRequest={handleSendHouseKeepingRequest}
									handleOptionChange={handleHouseKeepingOptionChange}
									selectedOptions={selectedHouseKeepingOptions}
								/>
							)}
						</div>
					)}

					{isLateCheckOutModalOpen && (
						<div className="fixed inset-0 bg-gray-700 bg-opacity-70 z-40">
							{guest && (
								<LateCheckoutTimePicker
									isModalOpen={isLateCheckOutModalOpen}
									setIsModalOpen={setIsLateCheckOutModalOpen}
									setRequestSent={(date, time) => {
										setLateCheckoOutSelectedTime(time);
										handleLateCheckOutAddon(time);
										//setSelectedDate(date);
										// setConfirmLateCheckOutRequest(true);
									}}
									addon={storeAddOns.allAddOns.find((addon) => {
										if (
											addon.addOnType !== "CustomAddon" &&
											addon.name
												.toLowerCase()
												.replace(/\s+/g, "")
												.includes("late")
										)
											return addon;
									})}
									propertyLateCheckOutTime={propertyLateCheckOutTime}
									propertyTime={propertyCheckOutTime}
									checkOutDate={guest.checkOut}
									propertyTimeZone={propertyTimeZone}
									lateCheckOutFlag={true}
								/>
							)}
						</div>
					)}
					<ToastContainer
						position="top-right"
						autoClose={5000}
						hideProgressBar
						newestOnTop={false}
						closeOnClick
						rtl={false}
						pauseOnFocusLoss
						draggable
						pauseOnHover
						theme="light"
						transition={Bounce}
					/>
					<div className="text-center mb-6 mt-12 text-gray-50 text-sm">
						Powered By Onelyk.Com
						<div className="mt-2 space-x-4">
							<a href="/terms" className="text-blue-400 hover:underline">
								Terms and Conditions
							</a>
							<a href="/privacy" className="text-blue-400 hover:underline">
								Privacy Policy
							</a>
						</div>
					</div>
				</div>
			)}
		</>
	);
};
